<input type="checkbox" [id]="id" [(ngModel)]="model" (blur)="onBlur()">
<label [class.cursor]="isClickableLabel" [for]="id"></label>
